export const SONY = 'SONY'
export const ORCHARD = 'ORCHARD'
